import axios from "axios";
import store from "../store/index";
import { baseApiUrl } from "./tenant";

const api = axios.create({
  baseURL: baseApiUrl,
  timeout: 600000,
});

const config = (config) => {
  const { tenantId, isRestNode } = config
  config.headers = {...config.headers, tenantId, isRestNode }
  return config
}
const success = (res) => res;
const error = async (error) => {
  const { noToast } = error.config;
  if (error.config && error.response && error.response.status === 401) {
    return store.dispatch("auth/refreshToken").then((response) => {
      error.config.headers["Authorization"] = "Bearer " + response.token;
      return axios.request(error.config);
    });
  }
  if (error.code == 'ECONNABORTED' && !noToast) { 
    store.dispatch('registers/showToast', { message: 'Requisição cancelada, tempo excedido', color: "error" })
  } else if (error.code == 'ERR_NETWORK' && !noToast) { 
    store.dispatch('registers/showToast', { message: 'Erro de conexão.', color: "error" })
  } else if (!noToast) {
    store.dispatch('registers/showToast', { message: error?.response?.data?.error || error?.response?.data || 'Erro interno.', color: "error" })
  }

  return Promise.reject(error);
};

api.interceptors.request.use(config)
api.interceptors.response.use(success, error);

export default api;
